import React from 'react';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const RepublicDayBlog = () => {
  const openInNewTab = (url) => {
    window.open(url, '_blank');
  };

  const products = [
    {
      img: '/affiliate/saree.jpg',
      title: 'Georgette Satin Floral Digital Printed Saree with Blouse_White',
      link: 'https://amzn.to/3CpNWEz',
    },
    {
      img: '/affiliate/dupatta.jpg',
      title: 'MULTI Colour Dupatta republic day',
      link: 'https://amzn.to/3EjslxX',
    },
    {
      img: '/affiliate/decore_republic_day.jpg',
      title: "DIGI ART'S Paper Tiranga Marigold Paper",
      link: 'https://amzn.to/3Eb2DvO',
    },
    {
      img: '/affiliate/republic_decore.jpg',
      title: 'Rozi Decoration Paper Fan Decor',
      link: 'https://amzn.to/4gaXLEa',
    },
    {
      img: '/affiliate/republic_party.jpg',
      title: 'Party Propz Republic Day Decoration Items',
      link: 'https://amzn.to/4gcB6HD',
    },
    {
      img: '/affiliate/republic.jpg',
      title: 'Arshia Fashions Republic Day Special Ethnic Wear Salwar Suit Set',
      link: 'https://amzn.to/42tRj82',
    },
  ];

  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 shadow mb-3">
          <h1>Republic Day: A Celebration of India’s Sovereignty and Unity</h1>
          <p><strong>Publish By: </strong>CodeInputs</p>
          <div className="text-center">
            <Image src="graphics/images/republicday.png" alt="Indian Republic Day" fluid />
          </div><br/>
          <p className="mt-4">Every year, on the 26th of January, India comes alive with a burst of patriotism, vibrant celebrations, and a deep sense of national pride. Republic Day marks the anniversary of the day India’s Constitution came into effect in 1950, transforming the nation into a sovereign, democratic republic. It’s a day of grandeur, filled with parades, cultural showcases, and tributes to the nation’s rich heritage. Beyond the ceremonial flag-hoisting and patriotic fervor, Republic Day is a time to reflect on our journey as a nation and honor the ideals enshrined in our Constitution. To add some extra sparkle to the occasion, let’s dive into some fun and fascinating facts about this historic day!</p>
          <p className="mt-4 blacktext">Here are some fascinating facts about Republic Day that every young Indian should be aware of.</p><br/>
          
          <h4>India's First Republic Day Parade</h4>
          <p>The first Republic Day parade was held at Rajpath, New Delhi, in 1950. Dr. Rajendra Prasad, the first President of India, took the salute.</p><br/>
          
          <h4>Drafting the Constitution</h4>

          <p>It took the Constituent Assembly 2 years, 11 months, and 18 days to draft the Indian Constitution, which is the longest written constitution in the world.</p><br/>
          
          <h4>Unique Date Selection</h4>

          <p>January 26 was chosen as Republic Day to honor the declaration of Purna Swaraj (complete independence) made by the Indian National Congress in 1930.</p><br/>
          
          <h4>Presidential Salute</h4>
          
          <p>On Republic Day, the President of India hoists the national flag and receives a 21-gun salute during the celebrations.</p><br/>
            
          <h4>Foreign Chief Guests</h4>
           
          <p> Each year, a foreign dignitary is invited as the Chief Guest. The first was the President of Indonesia, Dr. Sukarno, in 1950.</p><br/>

          <h4>Beating Retreat Ceremony</h4>

          <p>The Republic Day celebrations officially end on January 29 with the Beating Retreat Ceremony, which is a grand display of marching bands and military precision.</p><br/>

          <h4>Helicopter Petals</h4>

          <p>During the Republic Day parade, flower petals are showered from helicopters over the President and the audience, adding to the grandeur of the event.</p><br/>

          <h4>Children's Bravery Awards</h4>

          <p>The parade also honors children who have received the National Bravery Awards for their acts of courage and heroism.</p><br/>

          <h4>Tableaux Highlights</h4>

          <p>Each Indian state and Union Territory presents a tableau showcasing its culture, history, and achievements, making the parade a vibrant display of India's diversity.</p><br/>

          <h4>Tiranga (Tricolor)</h4>

          <p>The flag unfurling ceremony at Rajpath is synchronized with the playing of the national anthem and a massive crowd joining in with patriotic fervor.</p><br/>

          <h4>Vande Bharatam Performance</h4>

          <p>In recent years, cultural performances by artists and students from across the country, like the "Vande Bharatam" dance, have been introduced to highlight India’s rich heritage.</p><br/>

          <h4>Broadcast in Multiple Languages</h4>

          <p>The Republic Day parade is broadcast live in multiple languages on TV and radio to reach every corner of India.</p><br/>

          <h4>Constitution's Adoption</h4>

          <p>Although India became independent in 1947, it became a fully sovereign republic with the adoption of the Constitution on January 26, 1950.</p><br/>

          <h4>Special Coins Issued</h4>

          <p>The Indian government often releases commemorative coins on Republic Day to mark special milestones or achievements.</p><br/>

          <h4>Record-breaking Celebrations</h4>

          <p>The Republic Day parade is one of the largest ceremonial events in the world, drawing millions of viewers both in person and via broadcasts!</p><br/>
          {/* Add other sections similarly */}
          
          <h4>Some Products Available on Amazon:</h4>
          <Row>
            {products.map((product, index) => (
              <Col sm={6} className="text-center mt-5" key={index}>
                <Image src={product.img} width="100px" />
                <h6>{product.title}</h6>
                <Button variant="warning" onClick={() => openInNewTab(product.link)}>SHOP NOW</Button>
              </Col>
            ))}
          </Row>
        </Col>
        <Col sm={3}>
          <Card className="p-4 mb-3 shadow">
            <h4 className="mt-4 head-color">Recent Post</h4>
            <RecentPost />
          </Card>
          <Card className="p-4 shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p className="text-muted">No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default RepublicDayBlog;